module.exports = __webpack_public_path__ + "static/media/006-pompom-white.ee676843.svg";